export const STOMP_UPDATE = "SOCKETS_STOMP_UPDATE";